var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import InteractiveElement from 'nucleus-core/containers/InteractiveElement';
import Trigger from 'nucleus-core/containers/Trigger';
import Icon from '@cvent/nucleus-icon';
import { HAMBURGER, HORIZONTAL, TOPLEVEL, SUBLEVEL } from './Constants';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
* Normal view for the website navigator.
*/
var WebsiteNavigator = /** @class */ (function (_super) {
    __extends(WebsiteNavigator, _super);
    function WebsiteNavigator(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = _this.onClick.bind(_this);
        _this.subTriggers = {};
        _this.renderTrigger = _this.renderTrigger.bind(_this);
        _this.renderMenuItem = _this.renderMenuItem.bind(_this);
        _this.renderSubMenuOrItem = _this.renderSubMenuOrItem.bind(_this);
        _this.renderNavigationMenu = _this.renderNavigationMenu.bind(_this);
        return _this;
    }
    WebsiteNavigator.prototype.onClick = function (id) {
        var _this = this;
        return function () {
            if (_this.trigger) {
                _this.trigger.handleHide();
            }
            Object.keys(_this.subTriggers).forEach(function (subTriggerKey) { return _this.subTriggers[subTriggerKey] && _this.subTriggers[subTriggerKey].handleHide(); });
            _this.props.navigateToPage(id);
        };
    }; // Make trigger for dropdown or hamburger menu
    // Level switches the menu from a top level hamburger = 1 or other level, if not set defaults to 0..
    WebsiteNavigator.prototype.renderTrigger = function (menu, level, name, showAsSelectedGroup, id, isRightMostItem) {
        var _this = this;
        var _a = this.props, pageLinksArrangement = _a.pageLinksArrangement, selectedPage = _a.selectedPage, classes = _a.classes, style = _a.style, dimensions = _a.dimensions;
        var isEntireScreenAndFullWidth = !dimensions.maxWidth && !dimensions.contentWidth;
        var textAlign = this.props.style.navigation.textAlign;
        var dropDownShouldRightAlign = false;
        if (isEntireScreenAndFullWidth) {
            if (pageLinksArrangement === "HAMBURGER") {
                dropDownShouldRightAlign = textAlign === 'right';
            }
            else {
                dropDownShouldRightAlign = textAlign === 'right' ? isRightMostItem : false;
            }
        }
        var transDropdownStyles = resolve(this.props, 'transDropDown', dropDownShouldRightAlign ? 'rightAlign' : 'leftAlign');
        var containerClass = __assign(__assign({}, classes), { 
            // eslint-disable-next-line
            transitionContainer: level === TOPLEVEL ? transDropdownStyles.className : pageLinksArrangement === HAMBURGER ? classes.transInline : transDropdownStyles.className });
        var showAsSelectedLink = level === TOPLEVEL || showAsSelectedGroup;
        var pageLinkStyles = resolve(this.props, 'pageLinks', showAsSelectedLink ? 'selected' : '');
        pageLinkStyles.style.textAlign = 'left';
        return React.createElement(Trigger, { classes: containerClass, style: style, allowMouse: false, isTriggerFocusable: true, ref: function (ref) {
                /**
                 * PROD-86548: need to separate subMenu item trigger and toplevel trigger
                 * when there're 2 layers of dropdown to make it collapse correctly.
                 */
                if (level === SUBLEVEL) {
                    _this.subTriggers[id] = ref;
                }
                else {
                    _this.trigger = ref;
                }
            } },
            React.createElement("div", __assign({}, pageLinkStyles),
                React.createElement("span", { className: classes.selectedPage }, name || selectedPage.name),
                React.createElement(Icon, { icon: level === TOPLEVEL ? 'menuFilled' : 'expand', modifier: classes.menuIcon })),
            menu);
    }; // Individual link item
    WebsiteNavigator.prototype.renderMenuItem = function (page, menuType) {
        var selectedPage = this.props.selectedPage;
        var pageLinks = resolve(this.props, 'pageLinks', page.id === selectedPage.id ? 'selected' : '');
        pageLinks.style.textAlign = 'left';
        return React.createElement("li", __assign({ key: page.id }, resolve(this.props, 'menuItem', menuType)),
            React.createElement(InteractiveElement, __assign({}, pageLinks, { onClick: this.onClick(page.id) }), page.name));
    }; // Created Trigger and Sub Group pages
    WebsiteNavigator.prototype.renderSubMenuOrItem = function (item, menuType, itemIndex) {
        var _this = this;
        if (!item.childPages) {
            return this.renderMenuItem(item, menuType);
        }
        if (!item.childPages.length > 0) {
            return null;
        }
        var isRightMostItem = itemIndex === this.props.pageData.length - 1;
        var subMenu = React.createElement("ul", __assign({}, resolve(this.props, 'subMenu', menuType)), item.childPages.map(function (childItem) { return _this.renderSubMenuOrItem(childItem, 'sub', null); }));
        var selectedPage = this.props.selectedPage;
        var selectedPageInGroup = item.childPages.map(function (childPage) { return childPage.id; }).includes(selectedPage.id);
        return React.createElement("li", __assign({ key: item.id }, resolve(this.props, 'menuItem', menuType)), this.renderTrigger(subMenu, SUBLEVEL, item.name, selectedPageInGroup, item.id, isRightMostItem));
    }; // Parent Navigation UL - Create sub menu or direct link...
    WebsiteNavigator.prototype.renderNavigationMenu = function () {
        var _this = this;
        var _a = this.props, pageData = _a.pageData, pageLinksArrangement = _a.pageLinksArrangement;
        var textAlign = this.props.style.pageLinks.textAlign;
        var menuType = pageLinksArrangement === HAMBURGER ? 'vertical' : 'horizontal';
        return React.createElement("ul", __assign({}, resolve(this.props, textAlign, 'menu', menuType + "Menu")), pageData.map(function (item, index) { return _this.renderSubMenuOrItem(item, menuType, index); }));
    };
    WebsiteNavigator.prototype.render = function () {
        var _a = this.props, leftContent = _a.leftContent, rightContent = _a.rightContent, pageLinksArrangement = _a.pageLinksArrangement, id = _a.id; // Create Parent Navigation Container - Hamburger for desktop check...
        var content;
        if (pageLinksArrangement === HAMBURGER) {
            content = React.createElement("div", __assign({}, resolve(this.props, 'hamburgerWrapper')), this.renderTrigger(this.renderNavigationMenu(), TOPLEVEL, null, null, id, null));
        }
        else {
            content = this.renderNavigationMenu();
        }
        return React.createElement("div", __assign({}, resolveTestId(this.props), resolve(this.props, 'container')),
            leftContent && React.createElement("div", __assign({}, resolve(this.props, 'leftContent')), leftContent),
            React.createElement("div", __assign({}, resolve(this.props, 'navigation')), content),
            rightContent && React.createElement("div", __assign({}, resolve(this.props, 'rightContent')), rightContent));
    };
    WebsiteNavigator.displayName = 'WebsiteNavigator';
    WebsiteNavigator.propTypes = {
        id: PropTypes.string,
        selectedPage: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string
        }),
        pageData: PropTypes.array,
        navigateToPage: PropTypes.func,
        pageLinksArrangement: PropTypes.oneOf([HORIZONTAL, HAMBURGER]),
        leftContent: PropTypes.node,
        rightContent: PropTypes.node,
        dimensions: PropTypes.object
    };
    WebsiteNavigator.defaultProps = {
        dimensions: {
            maxWidth: 1024,
            contentWidth: 800
        }
    };
    return WebsiteNavigator;
}(React.Component));
export default WebsiteNavigator;
